import { z } from 'zod'

export const ADMINSOLOCLASSCODESPOSTEXPIRE_CONTRACT_VERSION = '1.0.0' as const
export const adminSoloClassCodesPostExpireResponseSchema = z.unknown()
export type AdminSoloClassCodesPostExpireResponse = z.infer<typeof adminSoloClassCodesPostExpireResponseSchema>
